import { FC } from 'react'
import { RenderIf } from '../RenderIf'
import { Button as ButtonStyled, ButtonSpinner } from './styled'
import { ButtonTypeExtended } from './types'

export const Button: FC<ButtonTypeExtended> = ({
  children,
  isLoading,
  onClick,
  ...props
}) => {
  const customOnClickHandler = () => {
    if (!isLoading && onClick) {
      onClick()
    }
  }
  return (
    <ButtonStyled onClick={customOnClickHandler} {...props}>
      <RenderIf condition={!isLoading}>{children}</RenderIf>
      <RenderIf condition={!!isLoading}>
        <ButtonSpinner data-testid="BUTTON_LOADING_SPINNER" />
      </RenderIf>
    </ButtonStyled>
  )
}
